import * as React from "react";
type Props = {
  className?: string,
};
function SvgLowerStress({ className }: Props) {
  return (
    <svg
      width="1em"
      height="1em"
      viewBox="0 0 49 48"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      data-testid="utility-LowerStress"
      className={className}
    >
      <path
        d="M35.0573 18.5482C35.0573 20.9314 33.3227 22.9085 31.0493 23.2897C30.7897 23.334 30.5221 23.3562 30.2493 23.3562H9.19023C6.04755 23.3562 3.5 20.8087 3.5 17.666C3.5 14.7347 5.71606 12.3217 8.56512 12.011C8.98014 8.07087 12.3134 5 16.3644 5C19.173 5 21.6369 6.47611 23.0217 8.69478C23.84 8.15047 24.8227 7.83341 25.8798 7.83341C28.7341 7.83341 31.0493 10.1473 31.0493 13.0028C31.0493 13.2731 31.0284 13.5392 30.988 13.7977C33.2915 14.1527 35.0573 16.1442 35.0573 18.5482Z"
        stroke="currentColor"
        strokeWidth={2}
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M15.6406 23.8844L12.2334 34.0153L18.6468 32.9791L17.4973 43L27.5798 27.6198L19.7462 28.8452L21.5249 23.7736"
        stroke="currentColor"
        strokeWidth={2}
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M39.248 21.6227V40.0058"
        stroke="currentColor"
        strokeWidth={2}
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M44.7633 34.7132L39.2782 40.7571L33.7334 34.6473"
        stroke="currentColor"
        strokeWidth={2}
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
}
export default SvgLowerStress;
